import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material/Select';
import { Select } from '../Select';
interface SearchSortProps {
  t: (key: string) => string;
  items: Array<{
    label: string;
    value: string;
  }>;
  onChange: (value: string) => void;
  initialValue: string;
  value?: string;
}
/**
 * Value prop changes when a user types in free text in the search input, if they have not selected a sort option yet.
 * This is used to sync the internal state with the external state. REF: libs/utils/src/utils/handleFreeTextSearch.ts
 */
const SearchSort = ({ t, items, onChange, initialValue, value }: SearchSortProps): JSX.Element => {
  const [selectedValue, setSelectedValue] = useState(value ?? initialValue);
  // Sync internal state when controlled value prop changes (e.g., from handleFreeTextSearch)
  useEffect(() => {
    if (value !== undefined && value !== selectedValue) {
      setSelectedValue(value);
    }
  }, [value]);
  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const newValue = event.target.value as string;
    if (newValue !== selectedValue) {
      onChange(newValue);
      setSelectedValue(newValue);
    }
  };
  return (
    <Select
      labelId="search-sort-label"
      label={t('ns.common:sort_by_label')}
      id="search-sort-select"
      value={selectedValue}
      fullWidth
      onChange={handleChange}
      sx={{
        mb: '20px',
      }}
    >
      {items.map(({ label, value }) => {
        return (
          <MenuItem key={label} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
};
export { SearchSort };
